module.exports = __webpack_public_path__ + "assets/img/icon_communication_and_collaboration_ability@2x.7483a0cc.png";